export default "__VITE_ASSET__D$u2tPXS__"